import React, {useState} from 'react'
import {
    Grid,
    makeStyles,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Button,
    Typography,
    Select,
    MenuItem,
    Slide,
    FormControl,
    Checkbox,
    FormControlLabel,
} from '@material-ui/core'
import get from 'get-value'
import set from 'set-value'
import _ from 'lodash'
import {Document, Page, pdfjs} from 'react-pdf'
import IconButton from '@material-ui/core/IconButton'
import CloseIcon from '@material-ui/icons/Close'
import clsx from 'clsx'
import Iframe from 'react-iframe'
const useStyles = makeStyles(theme => ({
    formControl: {
        minHeight: '77vh',
        maxHeight: '80vh',
        width: '100%',
    },
}))
const PdfViewer = props => {
    const classes = useStyles()
    const [isOpen, setIsOpen] = useState(true)
    const handlePopupClose = () => {
        props.isHide && props.isHide(false)
        setIsOpen(false)
    }
    return (
        <Grid item xs={12} className="agreement__pdf-wrapper">
            <div>
                <Dialog
                    open={isOpen}
                    onClose={handlePopupClose}
                    fullWidth
                    maxWidth={props.popopSize || 'md'}
                    fullScreen={props.fullScreen || false}
                    disableBackdropClick={true}
                    scroll="body"
                >
                    <DialogTitle
                        id="form-dialog-title"
                        className="edit-modal-wrapper__title"
                    >
                        <Grid className="modal-title-header cap-agreement__popup-header">
                            <Typography variant="h6" className="section-heading__h6">
                                {props.popopTitle}
                            </Typography>
                            <IconButton
                                aria-label="close"
                                className={clsx(classes.closeButton + ' close-icon')}
                                onClick={handlePopupClose}
                            >
                                <CloseIcon />
                            </IconButton>
                        </Grid>
                    </DialogTitle>
                    <DialogContent>
                        <Grid className="cap-agreement-view-pdf__wrapper">
                            <FormControl className={classes.formControl}>
                                <Grid item xs={12} className="pdf-view__wrapper">
                                    <PdfView {...props} />
                                </Grid>
                            </FormControl>
                        </Grid>
                    </DialogContent>
                    <DialogActions>
                        <Grid
                            container
                            spacing={2}
                            className="table-pagination__wrapper action--buttons__wrapper"
                        ></Grid>
                    </DialogActions>
                </Dialog>
            </div>
        </Grid>
    )
}
const PdfView = props => {
    pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`

    const [numPages, setNumPages] = useState(0)
    const [pageNumber, setPageNumber] = useState(0)
    function onDocumentLoadSuccess({numPages}) {
        setNumPages(numPages)
        setPageNumber(1)
    }

    return (
        <>
            {!props.showInIFrame && (
                <Document file={props.pdfViewURL} onLoadSuccess={onDocumentLoadSuccess}>
                    {_.times(numPages || 0, pn => {
                        return <Page pageNumber={pn + 1} key={`pageNumber_${pn + 1}`} />
                    })}
                </Document>
            )}
            {props.showInIFrame && (
                <Iframe
                    src={props.pdfViewURL}
                    width="100%"
                    //   height={(window.innerHeight / 100) * 70}
                    height="100%"
                    allow="fullscreen"
                    id="myId"
                    display="initial"
                    position="absolute"
                    loading="Loading..."
                />
            )}
        </>
    )
}

/* DEFAULT PROPS
================================================================ */
PdfViewer.defaultProps = {
    showInIFrame: true,
}

/* PROP TYPES
  ================================================================ */
PdfViewer.propTypes = {}

export default PdfViewer
